import React, { useEffect, useRef, useState } from 'react';

// Lazy mounts children only when it enters the viewport.
// Pass a render function as children to avoid constructing the element prematurely.
// Example: <InViewLazy>{() => <MyHeavyComponent />}</InViewLazy>
const InViewLazy = ({ children, rootMargin = '200px 0px' }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current || inView) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin, inView]);

  return (
    <div ref={ref}>
      {inView ? (typeof children === 'function' ? children() : children) : null}
    </div>
  );
};

export default InViewLazy;